import { AdminNavbar } from './navigation/AdminNavbar';

export const AdminLayout = ({ activeRoute, children, currentUser, onLogout, onNavigate }) => {
  return (
    <div className="container-fluid">
      <div className="row">
        <AdminNavbar
          activeRoute={activeRoute}
          currentUser={currentUser}
          onLogout={onLogout}
          onNavigate={onNavigate}
        />
        <div className="col-12 col-md-9 col-lg-10 ms-auto me-0 py-3 px-0">
          {children}
        </div>
      </div>
    </div>
  );
}

